// Configuration des images des catégories
// Les images sont stockées localement dans public/images/categories/

export const categoryImages = {
  'Fruits et Légumes': {
    path: '/images/categories/fruits-legumes.jpg',
    alt: 'Fruits et légumes frais'
  },
  'Viandes': {
    path: '/images/categories/viandes.jpg',
    alt: 'Viandes et charcuterie'
  },
  'Poissons': {
    path: '/images/categories/poissons.jpg',
    alt: 'Poissons et fruits de mer'
  },
  'Produits Laitiers': {
    path: '/images/categories/produits-laitiers.jpg',
    alt: 'Produits laitiers et fromages'
  },
  'Céréales et Pains': {
    path: '/images/categories/boulangerie.jpg',
    alt: 'Pain et viennoiseries'
  },
  'Boissons': {
    path: '/images/categories/boissons.jpg',
    alt: 'Boissons et rafraîchissements'
  },
  'Produits d\'Entretien': {
    path: '/images/categories/entretien.jpg',
    alt: 'Produits d\'entretien'
  },
  'Hygiène et Beauté': {
    path: '/images/categories/hygiene-beaute.jpg',
    alt: 'Produits d\'hygiène et beauté'
  },
  'Épicerie Salée': {
    path: '/images/categories/epicerie-sale.png',
    alt: 'Produits d\'épicerie salée'
  },
  'Épicerie Sucrée': {
    path: '/images/categories/epicerie-sucre.jpg',
    alt: 'Produits d\'épicerie sucrée'
  },
  'Surgelés': {
    path: '/images/categories/surgeles.jpg',
    alt: 'Produits surgelés'
  }
};

// Fonction utilitaire pour obtenir l'image d'une catégorie
export const getCategoryImage = (categoryName) => {
  return categoryImages[categoryName] || {
    path: '/images/categories/default.jpg',
    alt: 'Image par défaut'
  };
}; 